import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {CustomScrollbarModule} from '../../../../components/custom-scrollbar';
import {ElementRulerModule} from '../../../../components/element-ruler';
import {FlashMessageModule} from '../../../../components/flash-message';
import {WidgetRegistryService} from '../../../../components/layout/widget/widget-registry.service';
import {OverlayModule} from '../../../../components/overlay';
import {DisplayPositionFactory} from '../../../../components/position/display-position.factory';
import {ScrollbarWithEndingBlindsModule} from '../../../../components/scrollbar-with-ending-blinds';
import {StreamingModule} from '../../../../components/streaming';
import {TooltipModule} from '../../../../components/tooltip';
import {L10nModule} from '../../../../components/translate';
import {WidgetLinkingGroupModule} from '../../../../components/widget-linking-group';
import {AutofocusModule} from '../../../../directives/autofocus';
import {TextHidingModule} from '../../../../directives/text-hiding';
import {EmptyWidgetModule} from '../../../../widgets/empty-widget';
import {DisplayQuoteFactory} from '../../../../widgets/quotes-widget/display-quote.factory';
import {WidgetBodyRendererModule} from './widget-body-renderer';
import {WidgetHeaderComponent} from './widget-header';
import {WidgetHeaderTitleModule} from './widget-header/widget-header-title';
import {WidgetSettingsBodyRendererDirective, WidgetSettingsComponent} from './widget-settings';

@NgModule({
    imports:         [
        L10nModule,
        CommonModule,
        FormsModule,
        StreamingModule,
        AutofocusModule,
        TextHidingModule,
        OverlayModule,
        CustomScrollbarModule,
        WidgetBodyRendererModule,
        FlashMessageModule,
        TooltipModule,
        WidgetLinkingGroupModule,
        WidgetHeaderTitleModule,
        ScrollbarWithEndingBlindsModule,
        ElementRulerModule,
        EmptyWidgetModule
    ],
    declarations:    [
        WidgetSettingsComponent,
        WidgetHeaderComponent,
        WidgetSettingsBodyRendererDirective
    ],
    providers:       [
        DisplayPositionFactory,
        DisplayQuoteFactory,

        WidgetRegistryService
    ],
    exports:         [
        WidgetHeaderComponent,
        WidgetLinkingGroupModule
    ]
})
export class WidgetCommonModule {}
